import React, { useState } from "react";

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    zona: "",
    telefono: "",
    email: "",
    mensaje: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccessMessage("Tu mensaje ha sido enviado. ¡Gracias por contactarnos!");
        setFormData({
          nombre: "",
          zona: "",
          telefono: "",
          email: "",
          mensaje: "",
        });
      } else {
        setErrorMessage("Hubo un error al enviar el mensaje. Inténtalo de nuevo.");
      }
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      setErrorMessage("Error al enviar el mensaje. Inténtalo de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="contact" className="bg-[rgb(25,24,31)] text-white flex items-center justify-center py-8">
      <form onSubmit={handleSubmit} className="w-full max-w-7xl p-8 bg-gray-800 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold text-center mb-6">Contactanos</h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          {/* Nombre */}
          <div className="relative">
            <label className="flex items-center mb-2 text-gray-400 text-sm font-medium">
              Nombre
              <svg width="7" height="7" className="ml-1" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.11222 6.04545L3.20668 3.94744L1.43679 5.08594L0.894886 4.14134L2.77415 3.18182L0.894886 2.2223L1.43679 1.2777L3.20668 2.41619L3.11222 0.318182H4.19105L4.09659 2.41619L5.86648 1.2777L6.40838 2.2223L4.52912 3.18182L6.40838 4.14134L5.86648 5.08594L4.09659 3.94744L4.19105 6.04545H3.11222Z"
                  fill="#EF4444"
                />
              </svg>
            </label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              className="block w-full h-11 xl:pr-5 xl:pl-4 xl:py-2.5 text-center xl:text-start text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Ingresá tu nombre"
              required
            />
          </div>

          {/* Zona/Barrio */}
          <div className="relative">
            <label className="flex items-center mb-2 text-gray-400 text-sm font-medium">Zona/Barrio</label>
            <input
              type="text"
              name="zona"
              value={formData.zona}
              onChange={handleChange}
              className="block w-full h-11 xl:pr-5 xl:pl-4 xl:py-2.5 text-center xl:text-start text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Ingresá tu zona o barrio"
            />
          </div>

          {/* Teléfono */}
          <div className="relative">
            <label className="flex items-center mb-2 text-gray-400 text-sm font-medium">
              Teléfono
              <svg width="7" height="7" className="ml-1" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.11222 6.04545L3.20668 3.94744L1.43679 5.08594L0.894886 4.14134L2.77415 3.18182L0.894886 2.2223L1.43679 1.2777L3.20668 2.41619L3.11222 0.318182H4.19105L4.09659 2.41619L5.86648 1.2777L6.40838 2.2223L4.52912 3.18182L6.40838 4.14134L5.86648 5.08594L4.09659 3.94744L4.19105 6.04545H3.11222Z"
                  fill="#EF4444"
                />
              </svg>
            </label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              className="block w-full h-11 xl:pr-5 xl:pl-4 xl:py-2.5 text-center xl:text-start text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Ingresá tu teléfono"
              required
            />
          </div>

          {/* Email */}
          <div className="relative">
            <label className="flex items-center mb-2 text-gray-400 text-sm font-medium">
              Email
              <svg width="7" height="7" className="ml-1" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.11222 6.04545L3.20668 3.94744L1.43679 5.08594L0.894886 4.14134L2.77415 3.18182L0.894886 2.2223L1.43679 1.2777L3.20668 2.41619L3.11222 0.318182H4.19105L4.09659 2.41619L5.86648 1.2777L6.40838 2.2223L4.52912 3.18182L6.40838 4.14134L5.86648 5.08594L4.09659 3.94744L4.19105 6.04545H3.11222Z"
                  fill="#EF4444"
                />
              </svg>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="block w-full h-11 xl:pr-5 xl:pl-4 xl:py-2.5 text-center xl:text-start text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Ingresá tu email"
              required
            />
          </div>
        </div>

        {/* Mensaje */}
        <div className="relative mb-6">
          <label className="flex items-center mb-2 text-gray-400 text-sm font-medium">Mensaje</label>
          <textarea
            name="mensaje"
            value={formData.mensaje}
            onChange={handleChange}
            className="block w-full h-32 xl:pr-5 xl:pl-4 py-2.5 text-center xl:text-start text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            placeholder="Escribe tu mensaje"
          />
        </div>

        {/* Botón de envío */}
        <div className="flex items-center justify-center">
          <button
            type="submit"
            className="w-full max-w-md h-12 shadow-sm rounded-full bg-yellow-500 hover:bg-yellow-400 transition-all duration-300 text-black text-base font-semibold"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Enviando..." : "Enviar Mensaje"}
          </button>
        </div>

        {/* Mensajes de éxito y error */}
        {successMessage && <p className="text-green-400 mt-4">{successMessage}</p>}
        {errorMessage && <p className="text-red-400 mt-4">{errorMessage}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
